import { render, staticRenderFns } from "./CreateSearchFilterModal.vue?vue&type=template&id=4c372c42&"
import script from "./CreateSearchFilterModal.vue?vue&type=script&lang=js&"
export * from "./CreateSearchFilterModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CreateSearchFilterModal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c372c42')) {
      api.createRecord('4c372c42', component.options)
    } else {
      api.reload('4c372c42', component.options)
    }
    module.hot.accept("./CreateSearchFilterModal.vue?vue&type=template&id=4c372c42&", function () {
      api.rerender('4c372c42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/saved-search-filter/CreateSearchFilterModal.vue"
export default component.exports